import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
import { useState } from 'react'; // Added useState
// @mui
import { Box, List, ListItemText, Menu, MenuItem } from '@mui/material'; // Added Menu and MenuItem
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import SvgColor from '../svg-color/SvgColor';
import ModalLayout from 'src/theme/Modal';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

export default function NavSection({ data = [], ...other }) {
  const logout = { title: 'Logout', path: '', icon: icon('ic_lock') };

  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} />
        ))}
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, subMenuItems } = item; // Added subMenuItems
  const [anchorEl, setAnchorEl] = useState(null); // Added anchorEl state

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderSubMenu = () => {
    if (subMenuItems && subMenuItems.length > 0) {
      return (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          getContentAnchorEl={null}
        >
          {subMenuItems.map((subItem) => (
            <MenuItem key={subItem.title} component={RouterLink} to={subItem.path} onClick={handleClose}>
              {subItem.title}
            </MenuItem>
          ))}
        </Menu>
      );
    }
    return null;
  };

  return (
    <>
      <StyledNavItem
        component={subMenuItems ? 'div' : RouterLink} // If there are subMenuItems, use 'div' as component to handle the click event
        to={path}
        sx={{
          '&.active': {
            color: 'text.primary',
            //color: 'primary.light',
            bgcolor: 'action.selected',
            fontWeight: 'fontWeightBold',
          },
        }}
        onClick={handleClick} // Add onClick handler to open the dropdown menu
      >
        <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
        <ListItemText disableTypography primary={title} />
        {info && info}
      </StyledNavItem>
      {renderSubMenu()}
    </>
  );
}
